export default __webpack_public_path__ + "static/media/logo-gplay.5a838d6e.svg";